import { useCollection } from 'hooks/menu-collections'
import { useIsTutorialPending } from 'routes/Menu/hooks/useIsTutorialPending'

import { CollectionId } from '../../domains/collections'

export type RecommendationsCollectionForTutorial = {
  shortTitle?: string
}

export const useShowJFYTutorial = (
  recommendationsCollectionOverride?: RecommendationsCollectionForTutorial | null,
) => {
  const isJFYTutorialPending = useIsTutorialPending('justforyou')
  const storedRecommendationsCollection = useCollection(CollectionId.Recommendations)
  const recommendationsCollection =
    recommendationsCollectionOverride === undefined
      ? storedRecommendationsCollection
      : recommendationsCollectionOverride

  if (!isJFYTutorialPending) {
    return false
  }

  if (!recommendationsCollection) {
    return false
  }

  // previously we used to check if recommendations collection properties had tutorial = jfy
  // in menu v3 this data doesn't exist, but looking at the backend code, it seems that jfy was hardcoded
  return true
}
